/**
 * CMDPreviewPage.js — internal-only preview surface for the Scientific
 * Cohort View component. Used during Sprint 0 design review to take
 * screenshots without sloggning through the full Build Wave flow.
 *
 * Visit /cmd-preview?wave_id=<id> while logged in as an Enterprise brand.
 * DELETE THIS ROUTE before Sprint 1 ships.
 *
 * Why this file is OK to commit:
 *   - Same auth gates as production (uses `useAuth`).
 *   - Calls the same endpoints as production (no fixtures, no fakes).
 *   - Trivial to delete (just removes its Route registration).
 */
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import DashboardLayout from '../layouts/DashboardLayout';
import ScientificCohortView from '../components/dynamics/ScientificCohortView';

export default function CMDPreviewPage() {
  const [params] = useSearchParams();
  const waveId = params.get('wave_id');

  return (
    <DashboardLayout>
      <div className="max-w-4xl mx-auto p-6 space-y-4">
        <div>
          <p className="text-[10px] font-black uppercase tracking-widest text-gray-500">
            Sprint 0 · Internal Preview
          </p>
          <h1 className="text-xl font-bold text-white mt-1">
            Scientific Cohort View — Component Preview
          </h1>
          <p className="text-xs text-gray-500 mt-1">
            wave_id={waveId || '(none — pass ?wave_id=... in URL)'}
          </p>
        </div>
        <ScientificCohortView waveId={waveId} defaultExpanded />
      </div>
    </DashboardLayout>
  );
}
